import React, { Component } from "react";
import { connect } from "react-redux";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import { AGENT_PORTAL_URL, APP_LIVE_URL } from "../../../config/config";
import { withRouter } from "react-router-dom";
import { formatAsCurrency } from "../../../config/utility";
import {
  getSalesOrders,
  deleteAnswerOption,
  deleteQuestions,
  listActiveClients,
  getSingleQuotation,
  listSingleClient,
  getAssignedQuotationSettings,
  getSingleRfq,
  createDuplicateOrder,
  deleteSalesOrder,
} from "./../../../config/reseller_api_calls";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import { addSettings, addMsaInfo } from "../../../actions";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import { Invoice } from "../../../components/ContentLoaders/newLoaders/Invoice";
import { Fileupload } from "../../../components/Image/Fileupload";
import Tooltip from "@material-ui/core/Tooltip";
import MutextField from "@material-ui/core/TextField";
import dateFormat, { masks } from "dateformat";
import DataTable from "../../../components/Tables/DataTable";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import localization from "../../../localization/localization";
import UserPermissionHelper from "../../../components/Reseller/UserPermissionHelper";
import CreateInvoiceModal from "../../../components/Invoices/CreateInvoiceModal";
import NotificationToast from "../../../components/Notification/NotificationToast";

const animatedComponents = makeAnimated();

const auth = new HelperClass();

// Wrap on word boundaries; only break a token that genuinely cannot fit.
// `wordBreak: normal` overrides the theme's break-all, which was splitting
// email addresses mid-word in the Client and Partner columns.
const WRAP_CELL_STYLE = {
  whiteSpace: "normal",
  wordBreak: "normal",
  overflowWrap: "break-word",
  minWidth: "180px",
};

// Dates are short and must never split across two lines.
const NOWRAP_CELL_STYLE = { whiteSpace: "nowrap" };

const parseDateLocal = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
};

const options = [
  { name: "Swedish", value: "sv" },
  { name: "English", value: "en" },
  { name: "Spanish", value: "es" },
  { name: "Urdu", value: "ur" },
];

class Quotations extends Component {
  constructor() {
    super();
    this.state = {
      tableData: [],
      errorMessage: "",
      agentId: "",
      formLoader: true,
      successMessage: "",
      fileErrorMessage: "",
      SmtpSuccessMessage: "",
      errorMessageDuplicate: "",
      smtp_reg_button: false,
      smtp_test_button: false,
      duplicate_button: false,
      invoice_loader: true,
      waitMessage: "",
      tableLoader: true,
      signup_link: "",
      copied: false,
      copied2: false,
      cpied_value: "",
      current_id: "",
      reg_button: false,
      reg_button_login: false,
      cancel_button: false,
      tableLoader: true,
      login_url: "",
      logo: "",
      signature_image: "",
      is_working: "",
      selected_options: [],
      optionErrorMessage: "",
      optionSuccessMessage: "",
      rfq_requirements: "",
      client_accountno: "",
      selected_accountno: null,
      all_active_clients: [],
      selected_account: "",
      rfq_accountno: "",
      rfq_attachment: "",
      all_answers: [],
      rfq_details: [],
      quotation_services: [],
      choose_accountno: "",
      errorMessageClient: "",
      next_sequence_no: null,
      //View Quotation
      client_details: [],
      client_name: "",
      client_company: "",
      client_email: "",
      client_phone: "",
      client_address: "",
      client_city: "",
      client_state: "",
      client_zip: "",
      reseller_name: "",
      reseller_company: "",
      reseller_email: "",
      reseller_phone: "",
      reseller_address: "",
      reseller_city: "",
      reseller_state: "",
      reseller_zip: "",
      reseller_details: [],
      //Services
      service_grand_total: 0,
      service_grand_sub_total: 0,
      //Discount Entries
      discount_type: "amount",
      discount_value: 0,
      discount_value_total: 0,
      discount_reason: "",
      //Shipping Entries
      shipping_title: "",
      shipping_value: 0,
      shipping_value_total: 0,
      //Tax Details
      tax_type: "amount",
      tax_value: 0,
      tax_value_total: 0,
      tax_reason: "",
      quote_title: "",
      quote_notes: "",
      //Quotation Settings
      payment_status: "",
      payment_terms: "",
      currency: "USD",
      contact_person: "",
      contact_email: "",
      validity: "",
      rows: [],
      rows_optional: [],
      quote_accountno: "",
      formLoaderDuplicate: false,
      rows_rfq_questions: [],
      rows_rfq_services: [],
      showTutorial: "No",
      permissionsState: [],
      permission_add: 0,
      permission_edit: 0,
      permission_view: 0,
      permission_duplicate_order: 0,

      // Delete sales order (soft delete)
      orderno_to_delete: "",
      errorMessageDelete: "",

      // Notification toast
      toastMessage: "",
      toastType: "success",
      toastTitle: "",

      // Create Invoice Modal (reusable component)
      showCreateInvoiceModal: false,
      createInvoiceSalesOrder: null,

      columnServices: [
        {
          name: "ordernos",
          label: "Order #",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return this.clickableCell(
                tableMeta.rowData[0],
                <div>{this.create_link(value, tableMeta)}</div>
              );
            },
          },
        },
        // {
        //   name: "ordernos",
        //   label: "Order #",
        //   options: { display: false },
        // },
        {
          name: "quote_accountno",
          label: "Quote #",
          options: {
            customBodyRender: (value, tableMeta) =>
              this.clickableCell(tableMeta.rowData[0], value ? value : "---"),
          },
        },
        {
          name: "rfq_accountno",
          label: "RFQ #",
          options: {
            customBodyRender: (value, tableMeta) =>
              this.clickableCell(tableMeta.rowData[0], value ? value : "---"),
          },
        },
        {
          name: "client_title",
          label: "Client",
          options: {
            // Wrap on word boundaries and only break a long token (an email)
            // when it genuinely cannot fit — the default was splitting
            // addresses mid-word, e.g. "jawad.ali+testclient / SO@tcpaas.com".
            setCellProps: () => ({ style: WRAP_CELL_STYLE }),
            customBodyRender: (value, tableMeta, updateValue) => {
              return this.clickableCell(
                tableMeta.rowData[0],
                <div>{this.defaultTitle(value, tableMeta)}</div>
              );
            },
            filterOptions: {
              renderValue: (value) => {
                return this.defaultTitle(value, null);
              },
            },
            customFilterListOptions: {
              render: (value) => {
                if (value && typeof value === "string") {
                  const parts = value.split("###");
                  if (parts.length > 1) {
                    const section = parts[1];
                    const name = section.split("<br>")[0];
                    const emailMatch = section.match(/>([^<]+@[^<]+)</);
                    const email = emailMatch ? emailMatch[1] : "";
                    return `${name} -${email}`;
                  }
                }
                return value;
              },
            },
          },
        },
        {
          name: "agent_title",
          label: localization.specificPortals.agentLabel,
          options: {
            setCellProps: () => ({ style: WRAP_CELL_STYLE }),
            customBodyRender: (value, tableMeta, updateValue) => {
              return this.clickableCell(
                tableMeta.rowData[0],
                <div>{this.agentTitle(value, tableMeta)}</div>
              );
            },
            filterOptions: {
              renderValue: (value) => {
                return this.agentTitle(value, null);
              },
            },
            customFilterListOptions: {
              render: (value) => {
                if (value && typeof value === "string") {
                  const name = value.split("<br>")[0];
                  const emailMatch = value.match(/>([^<]+@[^<]+)</);
                  const email = emailMatch ? emailMatch[1] : "";
                  return `${name} -${email}`;
                }
                return value;
              },
            },
          },
        },
        {
          // DB `order_created_date` — when the order record was created.
          name: "dateCreated",
          label: "Created Date",
          options: {
            setCellProps: () => ({ style: NOWRAP_CELL_STYLE }),
            customBodyRender: (value, tableMeta, updateValue) => {
              return this.clickableCell(tableMeta.rowData[0], <div>{value}</div>);
            },
          },
        },
        {
          // DB `dateCreated` — the issue date.
          name: "issue_date",
          label: "Issue Date",
          options: {
            setCellProps: () => ({ style: NOWRAP_CELL_STYLE }),
            customBodyRender: (value, tableMeta, updateValue) => {
              return this.clickableCell(
                tableMeta.rowData[0],
                <div>{value || "---"}</div>
              );
            },
          },
        },
        {
          name: "due_date",
          label: "Due Date",
          options: {
            setCellProps: () => ({ style: NOWRAP_CELL_STYLE }),
            customBodyRender: (value, tableMeta, updateValue) => {
              return this.clickableCell(
                tableMeta.rowData[0],
                <div>{value || "---"}</div>
              );
            },
          },
        },
          {
          name: "subscription_date",
          label: "Subscription Date",
          options: {
            setCellProps: () => ({ style: NOWRAP_CELL_STYLE }),
            customBodyRender: (value, tableMeta, updateValue) => {
              return this.clickableCell(
                tableMeta.rowData[0],
                <div>{value || "---"}</div>
              );
            },
          },
        },
        {
          name: "service_grand_total_amount",
          label: "Total Amount",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return this.clickableCell(
                tableMeta.rowData[0],
                <div>{formatAsCurrency(value || 0)}</div>
              );
            },
          },
        },
        {
          name: "invoiced_amount",
          label: "Invoiced",
          options: {
            customBodyRender: (value, tableMeta) => {
              const total = Number(tableMeta.rowData[9]) || 0;
              const invoiced = Number(value) || 0;
              const pct = total > 0 ? Math.min((invoiced / total) * 100, 100) : 0;
              const fullyInvoiced = total > 0 && invoiced >= total;
              return this.clickableCell(
                tableMeta.rowData[0],
                <div style={{ minWidth: 110 }}>
                  {fullyInvoiced ? (
                    <span style={{ color: "#1A7A4A", fontWeight: 600, fontSize: 12 }}>
                      Fully Invoiced ✓
                    </span>
                  ) : (
                    <span>{formatAsCurrency(invoiced)}</span>
                  )}
                  <div style={{ background: "#e9ecef", borderRadius: 3, height: 4, marginTop: 4 }}>
                    <div
                      style={{
                        background: fullyInvoiced ? "#1A7A4A" : "#1C5BDE",
                        width: pct + "%",
                        height: "100%",
                        borderRadius: 3,
                      }}
                    />
                  </div>
                </div>
              );
            },
          },
        },
        {
          name: "balance_amount",
          label: "Balance",
          options: {
            customBodyRender: (value, tableMeta) => {
              const total = Number(tableMeta.rowData[9]) || 0;
              const invoiced = Number(tableMeta.rowData[10]) || 0;
              const balance = Math.max(total - invoiced, 0);
              return this.clickableCell(
                tableMeta.rowData[0],
                <span style={{ color: balance > 0 ? "#D97706" : "#1A7A4A", fontWeight: 500 }}>
                  {formatAsCurrency(balance)}
                </span>
              );
            },
          },
        },
        {
          name: "invoice_count",
          label: "Invoices",
          options: {
            customBodyRender: (value, tableMeta) => {
              const orderno = tableMeta.rowData[0];
              const status = tableMeta.rowData[14];
              const count = Number(value) || 0;
              const total = Number(tableMeta.rowData[9]) || 0;
              const invoiced = Number(tableMeta.rowData[10]) || 0;
              const fullyInvoiced = total > 0 && invoiced >= total;
              return this.clickableCell(
                orderno,
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 4 }}>
                  {count > 0 ? (
                    <a
                      onClick={(e) => {
                        e.stopPropagation();
                        this.props.history.push(
                          `/invoices?orderno=${encodeURIComponent(orderno)}`
                        );
                      }}
                      style={{
                        cursor: "pointer",
                        color: "#1C5BDE",
                        fontSize: 12,
                        whiteSpace: "nowrap",
                        background: "rgba(28,91,222,0.08)",
                        borderRadius: 20,
                        padding: "2px 10px",
                        fontWeight: 500,
                      }}
                    >
                      {count} {count === 1 ? "invoice" : "invoices"}
                    </a>
                  ) : null}
                  {status === "completed" && count === 0 && !fullyInvoiced && total > 0 ? (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        this.open_create_invoice(tableMeta);
                      }}
                      style={{
                        background: "#101924",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        padding: "3px 10px",
                        fontSize: 11,
                        cursor: "pointer",
                        fontWeight: 500,
                        whiteSpace: "nowrap",
                      }}
                    >
                      + Create
                    </button>
                  ) : null}
                  {status === "completed" && count > 0 && !fullyInvoiced && total > 0 ? (
                    <a
                      onClick={(e) => {
                        e.stopPropagation();
                        this.open_create_invoice(tableMeta);
                      }}
                      style={{
                        cursor: "pointer",
                        color: "#1A7A4A",
                        fontSize: 11,
                        whiteSpace: "nowrap",
                        fontWeight: 500,
                      }}
                    >
                      + Add Invoice
                    </a>
                  ) : null}
                  {count === 0 && status !== "completed" ? (
                    <span style={{ color: "#9CA3AF" }}>---</span>
                  ) : null}
                </div>
              );
            },
          },
        },
        {
          name: "payment_status",
          label: "Payment Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return this.clickableCell(
                tableMeta.rowData[0],
                <div>{this.paymentStatus(value, tableMeta)}</div>
              );
            },
          },
        },
        {
          name: "quote_status",
          label: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return this.clickableCell(
                tableMeta.rowData[0],
                <div>{this.defaultText(value, tableMeta)}</div>
              );
            },
          },
        },
        {
          name: "ACTIONS",
          label: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              const orderno = tableMeta.rowData[0];
              const quoteAccountData = tableMeta.rowData[3];
              const invoiceCount = Number(tableMeta.rowData[12]) || 0;
              const paymentStatus = tableMeta.rowData[13];
              const status = tableMeta.rowData[14];

              const getaccount = quoteAccountData?.split("###");
              const viewLink = "/ViewSalesOrder/" + orderno;
              const editLink =
                "/EditSalesOrder/" +
                (getaccount ? getaccount[0] : "") +
                "/" +
                orderno +
                "?order=edit";

              const isDisabledGlobally =
                this.props.is_msa_signed === "No" ||
                this.props.defaultSettings === "missing";

              const canEditStatus =
                status === "draft" ||
                status === "pending" ||
                status === "in_review" ||
                (status === "completed" && paymentStatus === "unpaid");
              const hasInvoice = invoiceCount > 0;
              const isEditEnabled =
                canEditStatus && !isDisabledGlobally && !hasInvoice;
              const editTooltipTitle = hasInvoice
                ? "Cannot edit — invoice already exists"
                : "Edit order";

              // Mirrors DELETABLE_ORDER_STATUSES on the backend, which rejects
              // anything else regardless — this just greys the button out the
              // same way Edit does. Completed orders have been invoiced or paid
              // against, so they stay on the books.
              const canDeleteStatus =
                status === "draft" ||
                status === "pending" ||
                status === "in_review";
              const isDeleteEnabled = canDeleteStatus && !isDisabledGlobally;
              const deleteTooltipTitle = canDeleteStatus
                ? "Delete order"
                : "Completed and cancelled orders cannot be deleted";

              return (
                <div style={{ padding: "16px" }}>
                  {this.state.permissionsState &&
                  this.state.permissionsState.length > 0 &&
                  (this.state.permission_view === 1 ||
                    this.state.permission_edit === 1 ||
                    this.state.permission_duplicate_order === 1) ? (
                    <>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          minHeight: 36,
                        }}
                      >
                        {this.state.permissionsState &&
                        this.state.permissionsState.length > 0 &&
                        this.state.permission_view === 1 ? (
                          <Tooltip title="View order" placement="top">
                            <a
                              onClick={(e) => {
                                e.stopPropagation();
                                this.addMenuHistory(viewLink);
                              }}
                              style={{ cursor: "pointer" }}
                              disabled={isDisabledGlobally}
                            >
                              <em
                                className="icon ni ni-eye text-info"
                                style={{ fontSize: "20px" }}
                              />
                            </a>
                          </Tooltip>
                        ) : null}
                        {this.state.permissionsState &&
                        this.state.permissionsState.length > 0 &&
                        this.state.permission_edit === 1 ? (
                          <Tooltip title={editTooltipTitle}>
                            <a
                              onClick={(e) => {
                                e.stopPropagation();
                                if (isEditEnabled)
                                  this.addMenuHistory(editLink);
                              }}
                              style={{
                                cursor: isEditEnabled
                                  ? "pointer"
                                  : "not-allowed",
                                pointerEvents: isEditEnabled ? "auto" : "none",
                              }}
                            >
                              <em
                                className="icon ni ni-edit text-primary"
                                style={{
                                  fontSize: "20px",
                                  paddingLeft: "5px",
                                  borderLeft:
                                    this.state.permission_view === 1
                                      ? "1px solid rgb(0 0 0 / 87%)"
                                      : "none",
                                  opacity: isEditEnabled ? 1 : 0.3,
                                }}
                              />
                            </a>
                          </Tooltip>
                        ) : null}
                        {this.state.permissionsState &&
                        this.state.permissionsState.length > 0 &&
                        this.state.permission_duplicate_order === 1 ? (
                          <Tooltip title="Duplicate order" placement="top">
                            <a
                              onClick={(e) => {
                                e.stopPropagation();
                                this.open_duplicate(value, tableMeta);
                              }}
                              style={{
                                cursor: isDisabledGlobally
                                  ? "not-allowed"
                                  : "pointer",
                                pointerEvents: isDisabledGlobally
                                  ? "none"
                                  : "auto",
                              }}
                              disabled={isDisabledGlobally}
                            >
                              <em
                                className="icon ni ni-copy text-secondary"
                                style={{
                                  fontSize: 20,
                                  paddingLeft: 5,
                                  borderLeft:
                                    this.state.permission_view === 1 ||
                                    this.state.permission_edit === 1
                                      ? "1px solid rgb(0 0 0 / 87%)"
                                      : "none",
                                  opacity: isDisabledGlobally ? 0.3 : 1,
                                }}
                              />
                            </a>
                          </Tooltip>
                        ) : null}
                        {this.state.permissionsState &&
                        this.state.permissionsState.length > 0 &&
                        this.state.permission_edit === 1 ? (
                          <Tooltip title={deleteTooltipTitle} placement="top">
                            <a
                              onClick={(e) => {
                                e.stopPropagation();
                                if (isDeleteEnabled)
                                  this.open_delete_order(orderno);
                              }}
                              style={{
                                cursor: isDeleteEnabled
                                  ? "pointer"
                                  : "not-allowed",
                                pointerEvents: isDeleteEnabled ? "auto" : "none",
                              }}
                            >
                              <em
                                className="icon ni ni-trash text-danger"
                                style={{
                                  fontSize: 20,
                                  paddingLeft: 5,
                                  borderLeft:
                                    this.state.permission_view === 1 ||
                                    this.state.permission_edit === 1 ||
                                    this.state.permission_duplicate_order === 1
                                      ? "1px solid rgb(0 0 0 / 87%)"
                                      : "none",
                                  opacity: isDeleteEnabled ? 1 : 0.3,
                                }}
                              />
                            </a>
                          </Tooltip>
                        ) : null}
                      </div>
                    </>
                  ) : (
                    "---"
                  )}
                </div>
              );
            },
          },
        },
      ],
    };
  }

  async componentDidMount() {
    let client_accountno = this.props.match.params.client_accountno;
    this.setState({
      client_accountno: client_accountno,
    });
    const servicesResponce = await getSalesOrders(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );
    // console.log("getSalesOrders: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableData: [],
        tableLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let showTutorialSetting = "No";
      if (
        servicesResponce.data.custom_settings &&
        servicesResponce.data.custom_settings.length > 0 &&
        servicesResponce.data.custom_settings[0].show_tutorial
      ) {
        showTutorialSetting =
          servicesResponce.data.custom_settings[0].show_tutorial;
      }

      this.setState({
        tableData: servicesResponce.data.data.map((row) => ({
          ...row,
          dateCreated: (() => { const d = parseDateLocal(row.dateCreated); return d ? dateFormat(d, "mm-dd-yyyy") : "---"; })(),
          due_date: (() => { const d = parseDateLocal(row.due_date); return d ? dateFormat(d, "mm-dd-yyyy") : "---"; })(),
          issue_date: (() => { const d = parseDateLocal(row.issue_date); return d ? dateFormat(d, "mm-dd-yyyy") : "---"; })(),
          subscription_date: (() => { const d = parseDateLocal(row.subscription_date); return d ? dateFormat(d, "mm-dd-yyyy") : "---"; })(),
        })),
        tableLoader: false,
        showTutorial: showTutorialSetting,
        next_sequence_no: servicesResponce.data.next_sequence_no || null,
      });
    } else {
      this.setState({
        tableData: [],
        tableLoader: false,
      });
      // window.location.replace("/error");
    }
    this.listAllActiveClients();

    if (this.props.userRoleItems && this.props.userRoleItems.length > 0) {
      const canEdit = UserPermissionHelper.getAllRoles(
        this.props.userRoleItems,
        "sales",
        "sales_orders",
      );
      // console.log("Can Edit Clients (mount):", canEdit);

      this.setState({
        permissionsState: canEdit,
        permission_add: canEdit[0].add,
        permission_edit: canEdit[0].edit,
        permission_view: canEdit[0].view,
        permission_duplicate_order: canEdit[0].duplicate,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userRoleItems !== this.props.userRoleItems) {
      const canEdit = UserPermissionHelper.getAllRoles(
        this.props.userRoleItems,
        "sales",
        "sales_orders",
      );
      // console.log("Can Edit Clients:", canEdit);

      this.setState({
        permissionsState: canEdit,
        permission_add: canEdit[0].add,
        permission_edit: canEdit[0].edit,
        permission_view: canEdit[0].view,
        permission_duplicate_order: canEdit[0].duplicate,
      });
      // console.log("Can Edit Clients:", canEdit);
    }
  }

  listAllActiveClients = async () => {
    const servicesResponce = await listActiveClients(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("listAllActiveClients: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      //auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        errorMessage: "The question not found.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let all_clients = [];
      if (
        servicesResponce.data.all_data &&
        servicesResponce.data.all_data.length > 0
      ) {
        for (let i = 0; i < servicesResponce.data.all_data.length; i++) {
          let newArr = {
            label:
              servicesResponce.data.all_data[i]["name"] +
              " (" +
              servicesResponce.data.all_data[i]["comp_name"] +
              ")",
            value: servicesResponce.data.all_data[i]["accountno"],
          };
          all_clients.push(newArr);
        }
      }
      this.setState({
        all_active_clients: all_clients,
      });
    } else {
      this.setState({
        errorMessage: "",
      });
    }
  };

  // create_link = (value, tableMeta) => {
  //   let quote_accountno = tableMeta.rowData[0];
  //   if (quote_accountno !== "") {
  //     return (
  //       <div>
  //         <a
  //           style={{ cursor: "pointer", textDecoration: "underline" }}
  //           className="text-primary"
  //           onClick={() =>
  //             this.addMenuHistory("/ViewSalesOrder/" + tableMeta.rowData[0])
  //           }
  //           data-toggle="tooltip"
  //           data-placement="top"
  //           title="View Quotation"
  //           disabled={
  //             this.props.is_msa_signed === "No" ||
  //             this.props.defaultSettings === "missing"
  //               ? true
  //               : false
  //           }
  //         >
  //           {quote_accountno}
  //         </a>
  //       </div>
  //     );
  //   }
  // };

  clickableCell = (orderno, content) => {
    if (!orderno) return content;
    const isDisabledGlobally =
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing";
    if (isDisabledGlobally) return content;
    return (
      <div
        onClick={() => this.addMenuHistory("/ViewSalesOrder/" + orderno)}
        style={{ cursor: "pointer", display: "block", width: "100%", padding: "16px" }}
      >
        {content}
      </div>
    );
  };

  create_link = (value, tableMeta) => {
    let quote_accountno = tableMeta.rowData[0];
    if (quote_accountno !== "") {
      return (
        <div>
          {this.state.permissionsState &&
          this.state.permissionsState.length > 0 &&
          this.state.permission_view === 1 ? (
            <a
              style={{ cursor: "pointer", textDecoration: "underline" }}
              className="text-primary"
              onClick={() =>
                this.addMenuHistory("/ViewSalesOrder/" + tableMeta.rowData[0])
              }
              data-toggle="tooltip"
              data-placement="top"
              title="View Quotation"
              disabled={
                this.props.is_msa_signed === "No" ||
                this.props.defaultSettings === "missing"
                  ? true
                  : false
              }
            >
              {quote_accountno}
            </a>
          ) : (
            quote_accountno
          )}
        </div>
      );
    }
  };

  create_link_quotation = (value, tableMeta) => {
    let quote_accountno = tableMeta.rowData[1];
    if (quote_accountno !== "") {
      return (
        <div>
          <a
            style={{ cursor: "pointer", textDecoration: "underline" }}
            className="text-primary"
            onClick={() =>
              this.addMenuHistory("ViewQuotation/" + tableMeta.rowData[1])
            }
            data-toggle="tooltip"
            data-placement="top"
            title="View Quotation"
            disabled={
              this.props.is_msa_signed === "No" ||
              this.props.defaultSettings === "missing"
                ? true
                : false
            }
          >
            {quote_accountno}
          </a>
        </div>
      );
    }
  };

  reloadClients = async () => {
    this.setState({
      tableLoader: true,
    });
    const servicesResponce = await getSalesOrders(
      auth.getAccount(),
      auth.getToken(),
      this.state.client_accountno,
    );
    // console.log("getRfqQuestions: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableData: [],
        tableLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableData: servicesResponce.data.data.map((row) => ({
          ...row,
          dateCreated: (() => { const d = parseDateLocal(row.dateCreated); return d ? dateFormat(d, "mm-dd-yyyy") : "---"; })(),
          due_date: (() => { const d = parseDateLocal(row.due_date); return d ? dateFormat(d, "mm-dd-yyyy") : "---"; })(),
          issue_date: (() => { const d = parseDateLocal(row.issue_date); return d ? dateFormat(d, "mm-dd-yyyy") : "---"; })(),
          subscription_date: (() => { const d = parseDateLocal(row.subscription_date); return d ? dateFormat(d, "mm-dd-yyyy") : "---"; })(),
        })),
        tableLoader: false,
        next_sequence_no: servicesResponce.data.next_sequence_no || null,
      });
    } else {
      this.setState({
        tableData: [],
        tableLoader: false,
      });
      // window.location.replace("/error");
    }
  };

  renderSearchIcon = () => (
    <span role="img" aria-label="drop-down-icon">
      ▼
    </span>
  );

  defaultText = (value, tableMeta) => {
    let is_default = value;

    if (is_default === "draft") {
      return <span className="badge badge-outline-secondary">Draft</span>;
    } else if (is_default === "pending") {
      return <span className="badge badge-outline-primary">Pending</span>;
    } else if (is_default === "completed") {
      return <span className="badge badge-outline-success">Completed</span>;
    } else if (is_default === "cancelled") {
      return <span className="badge badge-outline-danger">Cancelled</span>;
    } else if (is_default === "in_review") {
      return <span className="badge badge-outline-warning">In Review</span>;
    }
  };

  paymentStatus = (value, tableMeta) => {
    let is_default = value;

    if (is_default === "unpaid") {
      return <span className="badge badge-outline-danger">Unpaid</span>;
    } else if (is_default === "paid") {
      return <span className="badge badge-outline-success">Paid</span>;
    } else if (is_default === "partial") {
      return <span className="badge badge-outline-warning">Partial</span>;
    } else {
      return <span className="badge badge-outline-danger">Unpaid</span>;
    }
  };

  defaultTitle = (value, tableMeta) => {
    if (value && value !== "") {
      let is_default = value.split("###");
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: is_default[1],
          }}
        />
      );
    }
    return "---";
  };

  agentTitle = (value, tableMeta) => {
    if (value && value !== "") {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: value,
          }}
        />
      );
    }
    return "---";
  };

  format_rfq_accountno = (value, tableMeta) => {
    let rfq_accountno = tableMeta.rowData[0].split("###");
    return rfq_accountno[0];
  };

  showQuotation = async (value, tableMeta) => {
    let all_data = tableMeta.rowData[3].split("###");
    let quote_accountno = tableMeta.rowData[0];
    let client_accountno = all_data[0];
    this.setState({
      quote_accountno: quote_accountno,
      invoice_loader: true,
      rfq_requirements: "",
    });
    window.$("#modalDefaultDetail").modal("show");
    // console.log(
    //   "quote_accountno client_accountno: " +
    //     quote_accountno +
    //     " " +
    //     client_accountno
    // );
    await this.getSingleQuotation(client_accountno, quote_accountno);
    await this.getQuotationSettings(quote_accountno);
    await this.getSingleClient(client_accountno);
  };

  getSingleQuotation = async (client_accountno, quote_accountno) => {
    const servicesResponce = await getSingleQuotation(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
      quote_accountno,
    );
    // console.log("getSingleQuotation: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
      this.setState({ invoice_loader: false });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let discount_value_total = 0;
      let discount_type = "amount";
      let discount_value = 0;
      let discount_reason = "";
      if (
        servicesResponce.data.data[0]["discounts"] &&
        servicesResponce.data.data[0]["discounts"].length > 0
      ) {
        discount_value_total =
          servicesResponce.data.data[0]["discounts"][0]["discount_total"];
        discount_type =
          servicesResponce.data.data[0]["discounts"][0]["discount_type"];
        discount_value =
          servicesResponce.data.data[0]["discounts"][0]["discount_value"];
        discount_reason =
          servicesResponce.data.data[0]["discounts"][0]["discount_reason"];
      }
      let tax_value_total = 0;
      let tax_type = "amount";
      let tax_value = 0;
      let tax_reason = "";
      if (
        servicesResponce.data.data[0]["taxes"] &&
        servicesResponce.data.data[0]["taxes"].length > 0
      ) {
        tax_value_total =
          servicesResponce.data.data[0]["taxes"][0]["tax_total"];
        tax_type = servicesResponce.data.data[0]["taxes"][0]["tax_type"];
        tax_value = servicesResponce.data.data[0]["taxes"][0]["tax_value"];
        tax_reason = servicesResponce.data.data[0]["taxes"][0]["tax_reason"];
      }
      let shipping_value_total = 0;
      let shipping_title = "";
      let shipping_value = "";
      if (
        servicesResponce.data.data[0]["shipping"] &&
        servicesResponce.data.data[0]["shipping"].length > 0
      ) {
        shipping_value_total =
          servicesResponce.data.data[0]["shipping"][0]["shipping_value"];
        shipping_title =
          servicesResponce.data.data[0]["shipping"][0]["shipping_title"];
        shipping_value =
          servicesResponce.data.data[0]["shipping"][0]["shipping_value"];
      }
      //console.log("rfq_questions: "+servicesResponce.data.data);
      let servicesRows = [];
      let total = 0;
      if (
        servicesResponce.data.data[0]["quote_services"] &&
        servicesResponce.data.data[0]["quote_services"].length > 0
      ) {
        let rfq_services = servicesResponce.data.data[0]["quote_services"];
        for (let i = 0; i < rfq_services.length; i++) {
          let newArray = {
            id: `row-${i}`,
            data: {
              id: rfq_services[i]["service_id"],
              name: rfq_services[i]["service_name"],
              quantity: rfq_services[i]["quantity"],
              unit: rfq_services[i]["service_unit"],
              price: rfq_services[i]["service_price"],
              total: Number(
                Number(rfq_services[i]["quantity"]) *
                  rfq_services[i]["service_price"],
              ).toFixed(2),
              type: rfq_services[i]["item_type"],
            },
          };
          servicesRows.push(newArray);
          total =
            total +
            Number(rfq_services[i]["service_price"]) *
              Number(rfq_services[i]["quantity"]);
        }
      }
      //Minus Discount
      let with_discount = total - parseFloat(discount_value_total);
      //Calculate Tax
      with_discount = with_discount + parseFloat(tax_value_total);
      //Calculate Shipping
      with_discount = with_discount + parseFloat(shipping_value_total);

      //**** Get Optional Services ****/rows_optional
      let servicesOptionalRows = [];
      if (
        servicesResponce.data.data[0]["quote_optional_services"] &&
        servicesResponce.data.data[0]["quote_optional_services"].length > 0
      ) {
        let optional_services =
          servicesResponce.data.data[0]["quote_optional_services"];
        for (let i = 0; i < optional_services.length; i++) {
          let newArrays = {
            id: `row-${i}`,
            data: {
              id: optional_services[i]["service_id"],
              name: optional_services[i]["service_name"],
              quantity: optional_services[i]["quantity"],
              unit: optional_services[i]["service_unit"],
              price: optional_services[i]["service_price"],
              total: Number(
                Number(optional_services[i]["quantity"]) *
                  optional_services[i]["service_price"],
              ).toFixed(2),
              type: optional_services[i]["item_type"],
            },
          };
          servicesOptionalRows.push(newArrays);
        }
      }
      this.setState({
        rows: servicesRows,
        rows_optional: servicesOptionalRows,
        quote_title: servicesResponce.data.data[0]["quote_title"],
        quote_notes: servicesResponce.data.data[0]["quote_notes"],
        quote_attachement: servicesResponce.data.data[0]["quote_attachement"],
        service_grand_total:
          with_discount && with_discount > 0
            ? with_discount.toFixed(2)
            : "0.00",
        service_grand_sub_total: total && total > 0 ? total.toFixed(2) : "0.00",
        discount_value_total: discount_value_total,
        discount_type: discount_type,
        discount_value: discount_value,
        discount_reason: discount_reason,
        tax_value_total: tax_value_total,
        tax_type: tax_type,
        tax_value: tax_value,
        tax_reason: tax_reason,
        shipping_value_total: shipping_value_total,
        shipping_value: shipping_value,
        shipping_title: shipping_title,
        payment_status: servicesResponce.data.data[0]["payment_status"],
        tableLoader: false,
        invoice_loader: false,
      });
      if (
        servicesResponce.data.data[0]["rfq_accountno"] &&
        servicesResponce.data.data[0]["rfq_accountno"] !== ""
      ) {
        await this.getSingleRfq(
          client_accountno,
          servicesResponce.data.data[0]["rfq_accountno"],
        );
      }
    } else {
      // window.location.replace("/error");
      this.setState({ invoice_loader: false });
    }
  };

  getQuotationSettings = async (quote_accountno) => {
    const servicesResponce = await getAssignedQuotationSettings(
      auth.getAccount(),
      auth.getToken(),
      quote_accountno,
    );
    // console.log("getQuotationSettings: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        payment_terms: servicesResponce.data.data[0]["payment_terms"],
        currency: servicesResponce.data.data[0]["currency"].toUpperCase(),
        contact_person: servicesResponce.data.data[0]["contact_person"],
        contact_email: servicesResponce.data.data[0]["contact_email"],
        validity: servicesResponce.data.data[0]["validity"],
        //quote_notes: servicesResponce.data.data[0]["quote_notes"],
        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
  };

  getSingleRfq = async (client_accountno, rfq_accountno) => {
    const servicesResponce = await getSingleRfq(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
      rfq_accountno,
    );
    // console.log("getSingleRfq: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      if (
        servicesResponce.data.data[0]["rfq_questions"] &&
        servicesResponce.data.data[0]["rfq_questions"].length > 0
      ) {
        let rfq_questions = servicesResponce.data.data[0]["rfq_questions"];
        for (let i = 0; i < rfq_questions.length; i++) {
          if (
            rfq_questions[i]["question_type"] === "radio" ||
            rfq_questions[i]["question_type"] === "dropdown"
          ) {
            let answer_id = this.doesAnswerIdExist(
              Number(rfq_questions[i]["answer_id"]),
              servicesResponce.data.all_answers,
            );

            rfq_questions[i]["answer"] = answer_id;
          } else if (rfq_questions[i]["question_type"] === "checkbox") {
            let answer_id = this.doesAnswerArrayExist(
              JSON.parse(rfq_questions[i]["answer_id"]),
              servicesResponce.data.all_answers,
            );

            rfq_questions[i]["answer"] = answer_id;
          } else {
            rfq_questions[i]["answer"] = rfq_questions[i]["answer_id"];
          }
        }
      }

      //console.log("rfq_questions: "+servicesResponce.data.data);
      let servicesRows = [];
      if (
        servicesResponce.data.data[0]["rfq_services"] &&
        servicesResponce.data.data[0]["rfq_services"].length > 0
      ) {
        let rfq_services = servicesResponce.data.data[0]["rfq_services"];
        for (let i = 0; i < rfq_services.length; i++) {
          let newArray = {
            id: `row-${i}`,
            data: {
              id: rfq_services[i]["service_id"],
              name: rfq_services[i]["service_name"],
              quantity: rfq_services[i]["quantity"],
              unit: rfq_services[i]["service_unit"],
              price: 0,
              total: 0,
              type: "service",
            },
          };
          servicesRows.push(newArray);
        }
      }
      // console.log("servicesRows: ", servicesRows);
      this.setState({
        rows_rfq_services: servicesRows,
        //tableData: servicesResponce.data.data,
        rows_rfq_questions: servicesResponce.data.data[0]["rfq_questions"],
        //quotation_services: servicesResponce.data.data[0]["rfq_services"],
        rfq_requirements: servicesResponce.data.data[0]["rfq_comments"],
        rfq_attachment: servicesResponce.data.data[0]["rfq_attachement"],
        all_answers: servicesResponce.data.all_answers,

        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
  };

  getSingleClient = async (client_accountno) => {
    const servicesResponce = await listSingleClient(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );
    //console.log("getSingleClient: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        client_details: servicesResponce.data.client_details,

        //quote_notes: quotation_notes,
        client_name:
          servicesResponce.data.client_details[0]["name"] &&
          servicesResponce.data.client_details[0]["name"] !== ""
            ? servicesResponce.data.client_details[0]["name"]
            : "",
        client_company: servicesResponce.data.client_details[0]["comp_name"]
          ? servicesResponce.data.client_details[0]["comp_name"]
          : "",
        client_email: servicesResponce.data.client_details[0]["email"]
          ? servicesResponce.data.client_details[0]["email"]
          : "",
        client_phone: servicesResponce.data.client_details[0]["phone"]
          ? servicesResponce.data.client_details[0]["phone"]
          : "",
        client_address: servicesResponce.data.client_details[0]["address"]
          ? servicesResponce.data.client_details[0]["address"]
          : "",
        client_city: servicesResponce.data.client_details[0]["city"]
          ? servicesResponce.data.client_details[0]["city"]
          : "",
        client_state: servicesResponce.data.client_details[0]["state"]
          ? servicesResponce.data.client_details[0]["state"]
          : "",
        client_zip: servicesResponce.data.client_details[0]["zip"]
          ? servicesResponce.data.client_details[0]["zip"]
          : "",
        reseller_details: servicesResponce.data.reseller_details,
        reseller_name: servicesResponce.data.reseller_details[0]["name"]
          ? servicesResponce.data.reseller_details[0]["name"]
          : "",
        reseller_company: servicesResponce.data.reseller_details[0]["comp_name"]
          ? servicesResponce.data.reseller_details[0]["comp_name"]
          : "",
        reseller_email: servicesResponce.data.reseller_details[0]["email"]
          ? servicesResponce.data.reseller_details[0]["email"]
          : "",
        reseller_phone: servicesResponce.data.reseller_details[0]["phone"]
          ? servicesResponce.data.reseller_details[0]["phone"]
          : "",
        reseller_address: servicesResponce.data.reseller_details[0]["address"]
          ? servicesResponce.data.reseller_details[0]["address"]
          : "",
        reseller_city: servicesResponce.data.reseller_details[0]["city"]
          ? servicesResponce.data.reseller_details[0]["city"]
          : "",
        reseller_state: servicesResponce.data.reseller_details[0]["state"]
          ? servicesResponce.data.reseller_details[0]["state"]
          : "",
        reseller_zip: servicesResponce.data.reseller_details[0]["zip"]
          ? servicesResponce.data.reseller_details[0]["zip"]
          : "",
        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
  };

  doesAnswerIdExist = (answerIdToCheck, answerArray) => {
    //return answerArray.some((answer) => answer.answer_id === answerIdToCheck);
    const answer = answerArray.find((item) => item.id === answerIdToCheck);
    return answer ? answer.question_options : "";
  };

  doesAnswerArrayExist = (answerIdToCheck, answerArray) => {
    answerIdToCheck = JSON.stringify(answerIdToCheck);
    //return answerArray.some((answer) => answer.answer_id === answerIdToCheck);
    const objectValues = answerIdToCheck.slice(1, -1).split(",");
    var matchingItems = "";
    objectValues.map((setString, index) => {
      // console.log("setString: ", setString);
      let answer = answerArray.find((item) => item.id === Number(setString));
      if (answer) {
        matchingItems +=
          "<p>" + (Number(index) + 1) + ": " + answer.question_options + "</p>";
      }
    });

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: matchingItems,
        }}
      />
    );
  };

  viewQuestionType = (value, tableMeta) => {
    let domain_str = tableMeta.rowData[3];

    if (domain_str === "") {
      return "---";
    } else if (domain_str !== "") {
      return (
        <span className="badge badge-outline-dark">
          <em className="icon ni ni-card-view"></em> View
        </span>
      );
    }
  };

  viewPdf = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str && domain_str !== "") {
      return (
        <div>
          <a
            onClick={() => this.downloadPdf(value)}
            style={{ cursor: "pointer" }}
            title="Download Attachment"
          >
            <span className="badge badge-outline-secondary">
              {" "}
              <em className="icon ni ni-download"></em> View Attachment
            </span>
          </a>
        </div>
      );
    } else {
      return "---";
    }
  };

  downloadPdf = async (d_f_name) => {
    //var url = d_f_name;
    let file_name = d_f_name;
    var url = AGENT_PORTAL_URL + "files_data/rfq/" + d_f_name;
    fetch(url)
      .then((x) => x.blob())
      .then((b) => {
        // console.log("B INSTANCE", b instanceof Blob);
        const url = window.URL.createObjectURL(b);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = file_name;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        this.setState({
          errorMessage: "There is some error while downloading the attachment.",
        });
        setTimeout(() => {
          this.setState({ errorMessage: "" });
        }, 4000);
        // Handle any errors that occurred during the fetch
        console.error("Fetch error:", error);
      });
  };

  extractFileNameFromUrl = (url) => {
    const urlObject = new URL(url);
    const pathname = urlObject.pathname; // Gets the path after the domain
    const fileName = pathname.split("/").pop(); // Extracts the last segment after splitting by '/'
    return fileName;
  };

  format_date = (value, tableMeta) => {
    let date = value;
    if (date && date !== "") {
      return dateFormat(date, "mm-dd-yyyy, h:MM TT");
    } else {
      return "---";
    }
  };

  format_date_only = (value, tableMeta) => {
    let date = value;
    if (date && date !== "") {
      return dateFormat(date, "mm-dd-yyyy");
    } else {
      return "---";
    }
  };

  // Clearing first lets an identical consecutive message re-trigger the
  // toast's slide-in animation.
  showToast = (message, type = "success", title) => {
    this.setState({ toastMessage: "" }, () =>
      this.setState({
        toastMessage: message,
        toastType: type,
        toastTitle:
          title ||
          (type === "success"
            ? "Success"
            : type === "warning"
              ? "Warning"
              : type === "error"
                ? "Error"
                : "Info"),
      }),
    );
  };

  open_delete_order = (orderno) => {
    this.setState({
      orderno_to_delete: orderno,
      errorMessageDelete: "",
      disabled: false,
    });
    window.$("#modalDeleteOrder").modal("show");
  };

  deleteOrder = async () => {
    this.setState({
      errorMessageDelete: "",
      disabled: true,
    });

    const servicesResponce = await deleteSalesOrder(
      auth.getAccount(),
      auth.getToken(),
      this.state.orderno_to_delete,
    );

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      // The modal closes on success, so an inline message would never be seen —
      // the confirmation goes out as a toast instead.
      this.setState({
        errorMessageDelete: "",
        disabled: false,
      });
      window.$("#modalDeleteOrder").modal("hide");
      this.showToast("Sales order deleted successfully.", "success");
      this.reloadClients();
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "not_deletable"
    ) {
      // The order was completed or cancelled between the page load and the click.
      this.setState({
        errorMessageDelete:
          "This sales order can no longer be deleted. Please refresh the list.",
        disabled: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        errorMessageDelete: "The sales order was not found.",
        disabled: false,
      });
    } else {
      this.setState({
        errorMessageDelete:
          "There is some error while deleting the sales order.",
        disabled: false,
      });
    }

    setTimeout(() => {
      this.setState({ errorMessageDelete: "" });
    }, 5000);
  };

  deleteQuestions = async (value, tableMeta) => {
    let question_id = tableMeta.rowData[0];
    this.setState({
      errorMessage: "",
      successMessage: "",
      disabled: true,
    });

    const servicesResponce = await deleteQuestions(
      auth.getAccount(),
      auth.getToken(),
      question_id,
    );
    // console.log("addRfqQuestion: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      //auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        errorMessage: "The question not found.",
        successMessage: "",
        disabled: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        errorMessage: "",
        successMessage: "Question deleted successfully.",
        disabled: false,
      });
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    } else {
      this.setState({
        errorMessage: "There is some error while deleting the question.",
        successMessage: "",
        disabled: false,
      });
    }

    setTimeout(() => {
      this.setState({ errorMessage: "", successMessage: "" });
    }, 5000);
  };

  deleteOption = async (id, question_id) => {
    this.setState({
      optionErrorMessage: "",
      optionSuccessMessage: "",
      disabled: true,
    });

    const servicesResponce = await deleteAnswerOption(
      auth.getAccount(),
      auth.getToken(),
      id,
      question_id,
    );
    // console.log("addRfqQuestion: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      //auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        optionErrorMessage:
          "There is some error while deleting the answer option.",
        optionSuccessMessage: "",
        disabled: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        optionErrorMessage: "",
        optionSuccessMessage: "Answer option deleted successfully.",
        disabled: false,
      });
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    } else {
      this.setState({
        optionErrorMessage:
          "There is some error while adding the answer option.",
        optionSuccessMessage: "",
        disabled: false,
      });
    }

    setTimeout(() => {
      this.setState({ optionErrorMessage: "", optionSuccessMessage: "" });
    }, 5000);
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  /*handleChangeSearch = async (changed_value) => {
    console.log("handleChangeSearch: ", changed_value);
    if (changed_value) {
      this.setState(
        (prevState) => ({
          client_accountno: changed_value.value,
          selected_accountno: changed_value,
        }),
        () => {
          // This callback function is called right after the state is updated
          console.log("Updated state:", this.state.client_accountno);
          this.reloadClients();
        }
      );
    } else {
      this.setState({ selected_accountno: null });
    }
  };*/

  handleChangeSearch = async (changed_value) => {
    // console.log("handleChangeSearch: ", changed_value);

    if (changed_value) {
      this.setState(
        (prevState) => ({
          client_accountno: changed_value.value,
          selected_accountno: changed_value,
        }),
        () => {
          // This callback function is called right after the state is updated
          // console.log("Updated state:", this.state.client_accountno);
          this.reloadClients();
        },
      );
    } else {
      this.setState(
        {
          client_accountno: null,
          selected_accountno: null,
        },
        () => {
          // console.log("Cleared selection");
          this.reloadClients();
        },
      );
    }
  };

  handleChangeClient = async (changed_value) => {
    // console.log("handleChangeSearch: ", changed_value);
    if (changed_value) {
      this.setState(
        (prevState) => ({
          client_accountno: changed_value.value,
          choose_accountno: changed_value,
        }),
        () => {
          // This callback function is called right after the state is updated
          // console.log("Updated state:", this.state.client_accountno);
          //this.reloadClients();
        },
      );
    } else {
      this.setState({ choose_accountno: null });
    }
  };

  handleChangeDuplicate = async (changed_value) => {
    // console.log("handleChangeDuplicate: ", changed_value);
    if (changed_value) {
      this.setState(
        (prevState) => ({
          client_accountno: changed_value.value,
          choose_accountno_duplicate: changed_value,
        }),
        () => {
          // This callback function is called right after the state is updated
          // console.log("Updated state:", this.state.client_accountno);
          //this.reloadClients();
        },
      );
    } else {
      this.setState({ choose_accountno_duplicate: null });
    }
  };

  clearValue = () => {
    this.setState({ selected_accountno: null, choose_accountno: null });
  };

  validateIPAddress = (ipAddress) => {
    const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/;
    const isValid = ipRegex.test(ipAddress);
    //console.log(`Is IP Address valid? ${isValid}`);
    return isValid;
  };

  validateDomain = (domain) => {
    const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValid = domainRegex.test(domain);
    //console.log(`Is domain valid? ${isValid}`);
    if (isValid) {
      return true;
    }
    return false;
  };

  validateEmailAdd = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);
    //console.log("isValidEmail: " + " " + email + " = " + isValidEmail);
    if (isValidEmail) {
      return true;
    }
    return false;
  };

  addMenuHistory = (link) => {
    this.props.history.push(link);
  };

  open_duplicate = async (value, tableMeta) => {
    let quote_accountno = tableMeta.rowData[0];

    this.setState({
      errorMessageDuplicate: "",
      successMessageDuplicate: "",
      quote_accountno: quote_accountno,
      duplicate_button: false,
    });
    window.$("#modalFormDuplicate").modal("show");
  };

  create_duplicate = async () => {
    const { quote_accountno } = this.state;
    this.setState({ duplicate_button: true });
    const servicesResponce = await createDuplicateOrder(
      auth.getAccount(),
      auth.getToken(),
      quote_accountno,
    );
    // console.log("addRfqQuestion: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      //auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessageDuplicate:
          "There is some error while creating the copy of the sales order.",
        successMessageDuplicate: "",
        disabled: false,
        duplicate_button: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        errorMessageDuplicate: "",
        successMessageDuplicate: "Sales Order created successfully.",
        disabled: false,
        duplicate_button: true,
      });
      setTimeout(function () {
        window.location.replace(
          `/EditSalesOrder/${servicesResponce.data.client_accountno}/${servicesResponce.data.orderno}?order=edit`,
        );
      }, 3000);
    } else {
      this.setState({
        errorMessageDuplicate:
          "There is some error while creating the copy of the sales order.",
        successMessageDuplicate: "",
        disabled: false,
        duplicate_button: false,
      });
    }

    setTimeout(() => {
      this.setState({ errorMessageDuplicate: "", successMessageDuplicate: "" });
    }, 5000);
  };

  open_create_invoice = (tableMeta) => {
    const orderno = tableMeta.rowData[0];
    const orderRow =
      this.state.tableData.find(
        (r) => String(r.ordernos) === String(orderno) || String(r.orderno) === String(orderno),
      ) || {};
    const clientTitle = orderRow.client_title || tableMeta.rowData[3] || "";
    const orderTotal = Number(tableMeta.rowData[9]) || 0;
    const alreadyInvoiced = Number(tableMeta.rowData[10]) || 0;

    const parts = clientTitle.split("###");
    const clientAccountno = orderRow.client_accountno || parts[0] || "";
    const htmlContent = parts[1] || "";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;
    const rawText = (tempDiv.textContent || tempDiv.innerText || "").trim();
    const clientName =
      orderRow.customer_name || orderRow.contact_person || rawText.split("\n")[0].trim();
    const clientEmail = orderRow.customer_email || orderRow.contact_email || "";
    const currency = (orderRow.currency || this.state.currency || "USD").toString().toUpperCase();
    const resellerAccountno = orderRow.reseller_accountno || auth.getAccount();
    const invoiceTitle = orderRow.invoice_title || orderRow.quote_title || "";

    this.setState({
      showCreateInvoiceModal: true,
      createInvoiceSalesOrder: {
        orderno,
        client_accountno: clientAccountno,
        client_name: clientName,
        client_email: clientEmail,
        customer_name: clientName,
        customer_email: clientEmail,
        reseller_accountno: resellerAccountno,
        invoice_title: invoiceTitle,
        quote_title: invoiceTitle,
        currency,
        order_total: orderTotal,
        already_invoiced: alreadyInvoiced,
        billing_period: orderRow.billing_period || "",
        payment_terms: orderRow.payment_terms || "",
      },
    });
  };

  close_create_invoice = () => {
    this.setState({ showCreateInvoiceModal: false, createInvoiceSalesOrder: null });
  };

  handle_create_invoice_success = () => {
    this.setState({ showCreateInvoiceModal: false, createInvoiceSalesOrder: null });
    if (typeof this.reloadClients === "function") this.reloadClients();
  };

  open_video = async () => {
    this.setState({
      formLoader: false,
    });
    window.$("#modalFormVideo").modal("show");
    setTimeout(() => {
      this.setState({
        formLoader: false,
      });
    }, 2000);
  };

  open_clients = async () => {
    this.setState({
      formLoader: false,
      errorMessageClient: "",
    });
    window.$("#modalFormClients").modal("show");
    setTimeout(() => {
      this.setState({
        formLoader: false,
      });
    }, 2000);
  };

  add_sales_order = async () => {
    const { client_accountno, next_sequence_no } = this.state;
    if (client_accountno && client_accountno !== "") {
      window.$("#modalFormClients").modal("hide");
      
      const orderNo = next_sequence_no || null;
      this.addMenuHistory(
        "/EditSalesOrder/" +
          client_accountno +
          "/" +
          orderNo +
          "?order=add",
      );
    } else {
      this.setState({
        errorMessageClient: "Please choose a client.",
      });
    }
  };

  add_quotation = async () => {
    const { client_accountno } = this.state;
    if (client_accountno && client_accountno !== "") {
      window.$("#modalFormClients").modal("hide");
      this.addMenuHistory(
        "EditQuotations/" +
          client_accountno +
          "/" +
          this.generateRandomNumber() +
          "",
      );
    } else {
      this.setState({
        errorMessageClient: "Please choose a client.",
      });
    }
  };

  generateRandomNumber = () => {
    const min = 1000000; // Minimum 10-digit number (10^9)
    const max = 9999999; // Maximum 10-digit number (10^10 - 1)
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    return randomNumber;
  };

  render() {
    const searchParams = new URLSearchParams(window.location.search);
    const accountnoFromParams = searchParams.get("orderno");
    const log_type = searchParams.get("log_type");
    return (
      <div className="nk-content ">
        <NotificationToast
          message={this.state.toastMessage}
          type={this.state.toastType}
          title={this.state.toastTitle}
          onDismiss={() => this.setState({ toastMessage: "" })}
        />
        <div className="container-fluid">
          {/* MSA WARNING  START*/}
          {this.props.defaultSettings === "missing" &&
          this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {this.props.is_msa_signed === "No" &&
          this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}
          {/* MSA WARNING END */}
          <div className="nk-content-inner">
            <div className="nk-content-body">

              {this.props.from !== "dashboard" && (
                <div
                  className="nk-block-head nk-block-head-sm"
                  id="HeadContentSales"
                >
                  <div className="nk-block-between">
                    <div className="nk-block-head-content">
                      <Breadcrumbs aria-label="breadcrumb">
                        <Link
                          color="inherit"
                          onClick={() => this.addMenuHistory("/")}
                          className=""
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                        >
                          <HomeIcon fontSize="inherit" className="" />
                          Home
                        </Link>

                        <Typography color="textPrimary" className="">
                          Sale Orders
                        </Typography>
                      </Breadcrumbs>
                    </div>
                    <div className="nk-block-head-content" id="HeadContentAgent">
                      <div className="toggle-wrap nk-block-tools-toggle">
                        <a
                          href="#"
                          className="btn btn-icon btn-trigger toggle-expand mr-n1"
                          data-target="pageMenu"
                        >
                          <em className="icon ni ni-more-v"></em>
                        </a>
                        <div
                          className="toggle-expand-content"
                          data-content="pageMenu"
                        >
                          <ul className="nk-block-tools g-3">
                            {/* <li className="nk-block-tools-opt">
                              <a
                                href={
                                  process.env.REACT_APP_SALES_ORDER_KNOWLEDGE_BASE
                                }
                                target="_blank"
                                rel="noreferrer noopener"
                                className="btn btn-primary"
                                style={{ color: "#fff", cursor: "pointer" }}
                                onMouseDown={(e) => e.preventDefault()}
                              >
                                <em className="icon ni ni-info"></em>
                                &nbsp;Knowledge Base
                              </a>
                            </li>
                            {this.state.showTutorial === "Yes" && (
                              <li className="nk-block-tools-opt">
                                <a
                                  style={{ cursor: "pointer", color: "#fff" }}
                                  onClick={() => this.open_video()}
                                  className="btn btn-primary"
                                >
                                  <em className="icon ni ni-play-circle"></em>
                                  &nbsp;Video Tutorial
                                </a>
                              </li>
                            )} */}
                            {this.state.permissionsState &&
                            this.state.permissionsState.length > 0 &&
                            this.state.permission_add === 1 ? (
                              <li className="nk-block-tools-opt">
                                <a
                                  style={{ cursor: "pointer", color: "#fff" }}
                                  onClick={() => this.open_clients()}
                                  className="btn btn-primary"
                                >
                                  <em className="icon ni ni-plus-round"></em>
                                  &nbsp;Add New
                                </a>
                              </li>
                            ) : null}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}


              <div className="row g-gs">
                {/* Table 5th Col Start */}
                <div className="col-xxl-12">
                  <div className="nk-block nk-block-lg">
                    {this.state.errorMessage !== "" ? (
                      <div
                        className="example-alert"
                        style={{ marginBottom: "15px" }}
                      >
                        <div className="alert alert-pro alert-danger">
                          <div className="alert-text">
                            <h4>Error</h4>
                            <p>{this.state.errorMessage}</p>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {this.state.successMessage !== "" ? (
                      <div
                        className="example-alert"
                        style={{ marginBottom: "15px" }}
                      >
                        <div className="alert alert-pro alert-success">
                          <div className="alert-text">
                            <h4>Success</h4>
                            <p>{this.state.successMessage}</p>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    <div className="card" style={{ borderRadius: "0px" }}>
                      <div className="card-inner border-bottom">
                        <div className="row g-gs mb-3">
                          <div className="col-md-6">
                            <div className="form-group">
                              <div className="form-label-group">
                                <label className="form-label">
                                  Choose Client{" "}
                                  <span className="text-danger"></span>
                                </label>
                              </div>
                              <div className="form-control-group">
                                <Select
                                  options={this.state.all_active_clients}
                                  name="selected_accountno"
                                  placeholder="Select a client to view their orders."
                                  value={this.state.selected_accountno}
                                  autoComplete="off"
                                  emptyMessage="Clients not found"
                                  onChange={this.handleChangeSearch}
                                  isClearable
                                  isSearchable
                                  components={animatedComponents}
                                  styles={{
                                    control: (baseStyles, state) => ({
                                      ...baseStyles,
                                      lineHeight: "40px",
                                    }),
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* START DATATABLE */}
                    {this.state.tableLoader === true ? (
                      tableLoader()
                    ) : (
                      <div className="so-table-wrap">
                        <style>{`
                          .so-table-wrap td.MuiTableCell-body { padding: 0 !important; }
                        `}</style>
                        <DataTable
                          columns={this.state.columnServices}
                          tableData={this.state.tableData}
                          accountnoFromParams={accountnoFromParams}
                          log_type={log_type}
                          title=""
                          from="orders"
                        />
                      </div>
                    )}

                    {/* END TABLE */}
                  </div>
                </div>
                {/* Table 5th Col End */}
              </div>

              <div
                className="modal fade zoom"
                tabIndex="-1"
                id="modalFormOptions"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-list-round"></em> RFQ
                          Details{" "}
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {/* NRC DIVS START */}

                      {this.state.formLoader === true ? (
                        FormLoader()
                      ) : (
                        <>
                          <div>
                            <div className="card card-bordered">
                              <div className="card-inner-group">
                                <div className="card-inner">
                                  <div className="sp-plan-head">
                                    <h6 className="title">General Assesment</h6>
                                  </div>
                                  <div className="sp-plan-desc sp-plan-desc-mb">
                                    {this.state.rfq_details &&
                                    this.state.rfq_details.length > 0 ? (
                                      <table className="table table-striped">
                                        <thead>
                                          <tr>
                                            <th className="w-150px">
                                              Question
                                            </th>
                                            <th className="w-60">Answer</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.rfq_details[0].rfq_questions.map(
                                            (rfq, index) => (
                                              <tr key={index}>
                                                <td>{rfq.question}</td>
                                                <td>{rfq.answer}</td>
                                              </tr>
                                            ),
                                          )}
                                        </tbody>
                                      </table>
                                    ) : null}
                                  </div>
                                </div>
                                {this.state.quotation_services &&
                                this.state.quotation_services.length > 0 ? (
                                  <div className="card-inner">
                                    <div className="sp-plan-head">
                                      <h6 className="title">
                                        Products & Services
                                      </h6>
                                    </div>
                                    <div className="sp-plan-desc sp-plan-desc-mb">
                                      {this.state.rfq_details &&
                                      this.state.rfq_details.length > 0 ? (
                                        <table className="table table-striped">
                                          <thead>
                                            <tr>
                                              <th className="w-60">
                                                Product Name
                                              </th>
                                              <th>Qty</th>
                                              <th>Unit</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {this.state.quotation_services.map(
                                              (service, sid) => (
                                                <tr key={`ser${sid}`}>
                                                  <td>
                                                    {service.service_name}
                                                  </td>
                                                  <td>{service.quantity}</td>
                                                  <td>
                                                    {service.service_unit}
                                                  </td>
                                                </tr>
                                              ),
                                            )}
                                          </tbody>
                                        </table>
                                      ) : null}
                                    </div>
                                  </div>
                                ) : null}
                                {this.state.rfq_attachment &&
                                this.state.rfq_attachment !== "" ? (
                                  <div className="card-inner">
                                    <div className="sp-plan-head">
                                      <h6 className="title">Attachement</h6>
                                    </div>
                                    <div className="sp-plan-desc sp-plan-desc-mb">
                                      <ul className="row gx-1">
                                        <li className="col-sm-5">
                                          <p>
                                            <a
                                              onClick={() =>
                                                this.downloadPdf(
                                                  this.state.rfq_attachment,
                                                )
                                              }
                                              style={{ cursor: "pointer" }}
                                              title="Download Attachment"
                                            >
                                              <span className="badge badge-outline-secondary">
                                                {" "}
                                                <em className="icon ni ni-download"></em>{" "}
                                                Download Attachment
                                              </span>
                                            </a>
                                          </p>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                ) : null}

                                <div className="card-inner">
                                  <div className="sp-plan-head-group">
                                    <div className="sp-plan-head">
                                      <h6 className="title">Requirement</h6>
                                      <span className="ff-italic text-soft">
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: this.state.rfq_requirements,
                                          }}
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/**** Clients Modal ****/}

              <div
                className="modal fade zoom"
                tabIndex="-1"
                id="modalFormClients"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em
                            className="icon ni ni-user-list"
                            style={{ marginRight: "5px" }}
                          ></em>{" "}
                          Select Client{" "}
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {/* NRC DIVS START */}

                      {this.state.formLoader === true ? (
                        FormLoader()
                      ) : (
                        <>
                          <div>
                            <div className="row g-gs mb-3">
                              <div className="col-md-12">
                                {this.state.errorMessageClient !== "" ? (
                                  <div className="example-alert mb-2">
                                    <div className="alert alert-pro alert-danger alert-dismissible">
                                      <div className="alert-text">
                                        <h6>Error</h6>
                                        <p>{this.state.errorMessageClient} </p>
                                      </div>
                                      <button
                                        className="close"
                                        data-dismiss="alert"
                                      ></button>
                                    </div>
                                  </div>
                                ) : null}
                                <div className="form-group">
                                  <div className="form-label-group">
                                    <label className="form-label">
                                      Choose Client{" "}
                                      <span className="text-danger"></span>
                                    </label>
                                  </div>
                                  <div className="form-control-group">
                                    <Select
                                      options={this.state.all_active_clients}
                                      name="choose_accountno"
                                      placeholder="Select a client"
                                      value={this.state.choose_accountno}
                                      autoComplete="off"
                                      emptyMessage="Clients not found"
                                      onChange={this.handleChangeClient}
                                      isClearable
                                      isSearchable
                                      components={animatedComponents}
                                      styles={{
                                        control: (baseStyles, state) => ({
                                          ...baseStyles,
                                          lineHeight: "40px",
                                        }),
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <ul className="nk-stepper-pagination pt-4 gx-4 gy-2 stepper-pagination d-flex justify-content-end">
                                    <li className="step-next">
                                      <button
                                        type="button"
                                        className="btn btn-wider btn-primary"
                                        onClick={this.add_sales_order}
                                      >
                                        <span>Continue</span>
                                        <em className="icon ni ni-arrow-right"></em>
                                      </button>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/**** Clients Modal ****/}
              {/**** Video Modal ****/}

              <div
                className="modal fade zoom"
                tabIndex="-1"
                id="modalFormVideo"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-list-round"></em> How to
                          Create an Order{" "}
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {/* NRC DIVS START */}

                      {this.state.formLoader === true ? (
                        FormLoader()
                      ) : (
                        <>
                          <div>
                            <div className="row g-gs mb-3">
                              <div className="col-md-12">
                                <video width="100%" height="100%" controls>
                                  <source
                                    src={`${APP_LIVE_URL}files_data/kyc_signup/Create-a-Sales-Order.mp4`}
                                    type="video/mp4"
                                  />
                                  Your browser does not support the video tag.
                                </video>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/**** Video Modal ****/}
              {/**** Duplicate Modal ****/}
              <div
                className="modal fade zoom"
                tabIndex="-1"
                id="modalFormDuplicate"
              >
                <div
                  className="modal-dialog modal-lg modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em
                            className="icon ni ni-copy"
                            style={{ marginRight: "5px" }}
                          ></em>{" "}
                          Duplicate Sales Order{" "}
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      <div>
                        <div className="row g-gs mb-3">
                          <div className="col-md-12">
                            {this.state.errorMessageDuplicate !== "" ? (
                              <div className="example-alert mb-2">
                                <div className="alert alert-pro alert-danger alert-dismissible">
                                  <div className="alert-text">
                                    <h6>Error</h6>
                                    <p>{this.state.errorMessageDuplicate}</p>
                                  </div>
                                  <button
                                    className="close"
                                    data-dismiss="alert"
                                  ></button>
                                </div>
                              </div>
                            ) : null}
                            {this.state.successMessageDuplicate !== "" ? (
                              <div className="example-alert mb-2">
                                <div className="alert alert-pro alert-success alert-dismissible">
                                  <div className="alert-text">
                                    <h6>Success</h6>
                                    <p>{this.state.successMessageDuplicate}</p>
                                  </div>
                                  <button
                                    className="close"
                                    data-dismiss="alert"
                                  ></button>
                                </div>
                              </div>
                            ) : null}

                            {/* Replace select with confirmation message */}
                            <div className="form-group">
                              <p style={{ fontSize: "16px" }}>
                                Are you sure you want to duplicate this order?
                              </p>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <ul className="d-flex justify-content-end">
                                <li className="step-next">
                                  {this.state.duplicate_button === true ? (
                                    <button
                                      className="btn btn-primary"
                                      type="button"
                                      disabled
                                    >
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span> Creating Copy... </span>
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn btn-wider btn-primary"
                                      onClick={() => this.create_duplicate()}
                                    >
                                      <span>Create Copy</span>
                                      <em className="icon ni ni-arrow-right"></em>
                                    </button>
                                  )}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/**** Duplicate Modal ****/}

              <CreateInvoiceModal
                show={this.state.showCreateInvoiceModal}
                mode="standard"
                salesOrder={this.state.createInvoiceSalesOrder}
                onClose={this.close_create_invoice}
                onSuccess={this.handle_create_invoice_success}
              />

              {/*** Delete Sales Order Modal (soft delete) ***/}
              <div
                className="modal fade"
                tabIndex="-1"
                id="modalDeleteOrder"
              >
                <div className="modal-dialog modal-dialog-top" role="document">
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-danger"></em>
                        <h4 className="nk-modal-title">
                          Delete this sales order?
                        </h4>
                        <div className="nk-modal-text">
                          {this.state.errorMessageDelete !== "" ? (
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h6>Error</h6>
                                <p>{this.state.errorMessageDelete}</p>
                              </div>
                            </div>
                          ) : null}
                          <p className="text-soft">
                            Order #{this.state.orderno_to_delete} will be removed
                            from your sales orders list. Completed and cancelled
                            orders cannot be deleted.
                          </p>
                        </div>
                        <div className="nk-modal-action mt-5">
                          <a
                            href="#"
                            className="btn btn-lg btn-mw btn-light"
                            data-dismiss="modal"
                          >
                            CANCEL
                          </a>
                          <button
                            type="button"
                            className="btn btn-lg btn-mw btn-danger ml-2"
                            onClick={() => {
                              this.deleteOrder();
                            }}
                            disabled={this.state.disabled}
                          >
                            DELETE
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*** Details Modal ***/}
              <div className="modal fade" tabIndex="-1" id="modalDefaultDetail">
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        <em className="icon ni ni-file-docs"></em> Quotation Details
                        {this.state.payment_status === "unpaid" ? (
                          <span className="badge badge-pill badge-outline-danger ml-3">
                            Unpaid
                          </span>
                        ) : this.state.payment_status === "paid" ? (
                          <span className="badge badge-pill badge-outline-success ml-3">
                            Paid
                          </span>
                        ) : this.state.payment_status === "partial" ? (
                          <span className="badge badge-pill badge-outline-primary ml-3">
                            Partially Paid
                          </span>
                        ) : this.state.payment_status === "agreed" ? (
                          <span className="badge badge-pill badge-outline-warning ml-3">
                            Agreed (But not paid)
                          </span>
                        ) : null}
                      </h5>
                    </div>
                    <div className="modal-body ">
                      <div className="row g-gs">
                        <div className="col-md-12 invoice_details_popup">
                          {this.state.invoice_loader === true ? (
                            Invoice()
                          ) : (
                            <div className="nk-block">
                              <div className="invoice">
                                <div className="col-md-12 mb-3">
                                  <div className="d-flex justify-content-end">
                                    <ul className="nk-block-tools gx-3">
                                      <li className="btn-wrap">
                                        <a
                                          href="#"
                                          className="btn btn-icon btn-xl btn-dim btn-outline-light"
                                        >
                                          <em className="icon ni ni-emails"></em>
                                        </a>
                                        <span className="btn-extext">Send</span>
                                      </li>
                                      <li className="btn-wrap">
                                        <a
                                          href="#"
                                          className="btn btn-icon btn-xl btn-success"
                                        >
                                          <em className="icon ni ni-file-pdf"></em>
                                        </a>
                                        <span className="btn-extext">Download</span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="invoice-wrap">
                                  <div className="invoice-head">
                                    <div className="invoice-contact">
                                      <span className="overline-title">
                                        Quotation To
                                      </span>
                                      <div className="invoice-contact-info">
                                        <h4 className="title">
                                          {this.state.client_company}
                                        </h4>
                                        <ul className="list-plain">
                                          {this.state.client_address &&
                                          this.state.client_address !== "" ? (
                                            <li>
                                              <em className="icon ni ni-map-pin-fill"></em>
                                              <span>
                                                {this.state.client_address &&
                                                this.state.client_address !== ""
                                                  ? this.state.client_address
                                                  : ""}{" "}
                                                {this.state.client_city &&
                                                this.state.client_city !== ""
                                                  ? this.state.client_city
                                                  : ""}{" "}
                                                {this.state.client_state &&
                                                this.state.client_state !== ""
                                                  ? this.state.client_state
                                                  : ""}{" "}
                                                {this.state.client_zip &&
                                                this.state.client_zip !== ""
                                                  ? this.state.client_zip
                                                  : ""}
                                              </span>
                                            </li>
                                          ) : null}
                                          {this.state.client_phone &&
                                          this.state.client_phone !== "" ? (
                                            <li>
                                              <em className="icon ni ni-call-fill"></em>
                                              <span>
                                                {this.state.client_phone &&
                                                this.state.client_phone !== ""
                                                  ? auth.formatUsPhoneNumber(
                                                      this.state.client_phone,
                                                    )
                                                  : "---"}
                                              </span>
                                            </li>
                                          ) : null}
                                        </ul>
                                      </div>
                                    </div>
                                    <div className="invoice-desc right_invoice_details">
                                      <h3 className="title">Quotation</h3>
                                      <ul className="list-plain">
                                        <li className="invoice-id border-bottom">
                                          <span className="text-dark">
                                            Quotation No
                                          </span>
                                          :
                                          <span className="text-dark">
                                            {this.state.quote_accountno}
                                          </span>
                                        </li>
                                        <li className="invoice-date border-bottom">
                                          <span className="text-dark">
                                            Issue Date
                                          </span>
                                          :
                                          <span className="text-dark">
                                            {this.format_date(new Date())}
                                          </span>
                                        </li>
                                        <li className="invoice-date border-bottom">
                                          <span className="text-dark">
                                            From
                                          </span>
                                          :
                                          <span className="text-dark">
                                            {this.state.reseller_company}
                                          </span>
                                        </li>
                                        <li className="invoice-date border-bottom">
                                          <span className="text-dark">
                                            Company
                                          </span>
                                          :
                                          <span className="text-dark">
                                            {this.state.client_company}
                                          </span>
                                        </li>

                                        {this.state.payment_terms !== "" ? (
                                          <li className="invoice-date border-bottom">
                                            <span className="text-dark">
                                              Terms of Payment
                                            </span>
                                            :
                                            <span className="text-dark">
                                              {this.state.payment_terms}
                                            </span>
                                          </li>
                                        ) : null}
                                        {this.state.currency !== "" ? (
                                          <li className="invoice-date border-bottom">
                                            <span className="text-dark">
                                              Currency
                                            </span>
                                            :
                                            <span className="text-dark">
                                              {this.state.currency}
                                            </span>
                                          </li>
                                        ) : null}
                                        {this.state.contact_person !== "" ? (
                                          <li className="invoice-date border-bottom">
                                            <span className="text-dark">
                                              Contact Person{" "}
                                            </span>
                                            :
                                            <span className="text-dark">
                                              {this.state.contact_person}
                                            </span>
                                          </li>
                                        ) : null}
                                        {this.state.contact_email !== "" ? (
                                          <li className="invoice-date border-bottom">
                                            <span className="text-dark">
                                              Email
                                            </span>
                                            :
                                            <span className="text-dark">
                                              {this.state.contact_email}
                                            </span>
                                          </li>
                                        ) : null}
                                        {this.state.validity !== "" ? (
                                          <li className="invoice-date">
                                            <span className="text-dark">
                                              Validity
                                            </span>
                                            :
                                            <span className="text-dark">
                                              {this.state.validity} Days
                                            </span>
                                          </li>
                                        ) : null}
                                      </ul>
                                    </div>
                                  </div>
                                  <div className="invoice-bills">
                                    <div className="table-responsive">
                                      <table className="table table-striped">
                                        <thead>
                                          <tr>
                                            <th>ITEM ID</th>
                                            <th className="w-60">
                                              PRODUCT NAME
                                            </th>
                                            <th>QTY</th>
                                            <th>UNIT</th>
                                            <th>PRICE($)</th>
                                            <th>TOTAL($)</th>
                                          </tr>
                                        </thead>
                                        {this.state.rows &&
                                        this.state.rows.length > 0 ? (
                                          <>
                                            <tbody>
                                              {this.state.rows.map(
                                                (row, index) => (
                                                  <>
                                                    {row.data.type &&
                                                    row.data.type ===
                                                      "service" ? (
                                                      <tr key={`ind${index}`}>
                                                        <td>
                                                          {row.data.id &&
                                                          row.data.id !== ""
                                                            ? row.data.id
                                                            : "---"}
                                                        </td>
                                                        <td>
                                                          {row.data.name !== ""
                                                            ? row.data.name &&
                                                              row.data.name !==
                                                                ""
                                                              ? row.data.name
                                                              : "---"
                                                            : null}
                                                        </td>
                                                        <td>
                                                          {row.data.quantity}
                                                        </td>
                                                        <td>{row.data.unit}</td>
                                                        <td>
                                                          $
                                                          {Number(
                                                            row.data.price,
                                                          ).toFixed(2)}
                                                        </td>
                                                        <td>
                                                          {formatAsCurrency(
                                                            parseFloat(
                                                              row.data.total,
                                                            ),
                                                          )}
                                                        </td>
                                                      </tr>
                                                    ) : row.data.type ===
                                                      "section" ? (
                                                      <tr key={`ind${index}`}>
                                                        <td
                                                          className="text-left"
                                                          colSpan={6}
                                                        >
                                                          <strong>
                                                            {row.data.name !==
                                                            ""
                                                              ? row.data.name &&
                                                                row.data
                                                                  .name !== ""
                                                                ? row.data.name
                                                                : "---"
                                                              : null}
                                                          </strong>
                                                        </td>
                                                      </tr>
                                                    ) : row.data.type ===
                                                      "custom" ? (
                                                      <tr key={`ind${index}`}>
                                                        <td>
                                                          {row.data.id &&
                                                          row.data.id !== ""
                                                            ? row.data.id
                                                            : "---"}
                                                        </td>
                                                        <td>
                                                          {row.data.name !== ""
                                                            ? row.data.name &&
                                                              row.data.name !==
                                                                ""
                                                              ? row.data.name
                                                              : "---"
                                                            : null}
                                                        </td>
                                                        <td>
                                                          {row.data.quantity}
                                                        </td>
                                                        <td>{row.data.unit}</td>
                                                        <td>
                                                          $
                                                          {Number(
                                                            row.data.price,
                                                          ).toFixed(2)}
                                                        </td>
                                                        <td>
                                                          {formatAsCurrency(
                                                            parseFloat(
                                                              row.data.total,
                                                            ),
                                                          )}
                                                        </td>
                                                      </tr>
                                                    ) : null}
                                                  </>
                                                ),
                                              )}
                                            </tbody>
                                            <tfoot>
                                              <tr>
                                                <td colSpan="3"></td>
                                                <td colSpan="2">Subtotal</td>
                                                <td>
                                                  {formatAsCurrency(
                                                    parseFloat(
                                                      this.state
                                                        .service_grand_sub_total,
                                                    ),
                                                  )}
                                                </td>
                                              </tr>
                                              {this.state
                                                .discount_value_total &&
                                              this.state
                                                .discount_value_total !== "" ? (
                                                <tr>
                                                  <td colSpan="3"></td>
                                                  <td colSpan="2">Discount</td>
                                                  <td>
                                                    {formatAsCurrency(
                                                      parseFloat(
                                                        this.state
                                                          .discount_value_total,
                                                      ),
                                                    )}
                                                  </td>
                                                </tr>
                                              ) : null}
                                              {this.state
                                                .shipping_value_total &&
                                              this.state
                                                .shipping_value_total !== "" ? (
                                                <tr>
                                                  <td colSpan="3"></td>
                                                  <td colSpan="2">
                                                    Shipping & Delivery
                                                  </td>
                                                  <td>
                                                    {formatAsCurrency(
                                                      parseFloat(
                                                        this.state
                                                          .shipping_value_total,
                                                      ),
                                                    )}
                                                  </td>
                                                </tr>
                                              ) : null}
                                              {this.state.tax_value_total &&
                                              this.state.tax_value_total !==
                                                "" ? (
                                                <tr>
                                                  <td colSpan="3"></td>
                                                  <td colSpan="2">TAX</td>
                                                  <td>
                                                    {formatAsCurrency(
                                                      parseFloat(
                                                        this.state
                                                          .tax_value_total,
                                                      ),
                                                    )}
                                                  </td>
                                                </tr>
                                              ) : null}
                                              <tr>
                                                <td colSpan="3"></td>
                                                <td colSpan="2">Grand Total</td>
                                                <td>
                                                  {formatAsCurrency(
                                                    parseFloat(
                                                      this.state
                                                        .service_grand_total,
                                                    ),
                                                  )}
                                                </td>
                                              </tr>
                                            </tfoot>
                                          </>
                                        ) : null}
                                      </table>
                                    </div>
                                    <div className="col-xxl-12 mt-4">
                                      <div
                                        id="accordion-2"
                                        className="accordion accordion-s3"
                                      >
                                        <div className="accordion-item">
                                          <a
                                            href="#"
                                            className="accordion-head"
                                            data-toggle="collapse"
                                            data-target="#accordion-item-2-1"
                                          >
                                            <h6 className="title">Notes</h6>
                                            <span className="accordion-icon"></span>
                                          </a>
                                          <div
                                            className="accordion-body collapse show"
                                            id="accordion-item-2-1"
                                            data-parent="#accordion-2"
                                          >
                                            <div className="accordion-inner">
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    this.state.quote_notes,
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        {this.state.rows_optional &&
                                        this.state.rows_optional.length > 0 ? (
                                          <div className="accordion-item">
                                            <a
                                              href="#"
                                              className="accordion-head collapsed"
                                              data-toggle="collapse"
                                              data-target="#accordion-item-2-2"
                                            >
                                              <h6 className="title">
                                                Optional Products
                                              </h6>
                                              <span className="accordion-icon"></span>
                                            </a>
                                            <div
                                              className="accordion-body collapse"
                                              id="accordion-item-2-2"
                                              data-parent="#accordion-2"
                                            >
                                              <div className="accordion-inner">
                                                <div className="col-xxl-12">
                                                  <table className="table table-striped">
                                                    <thead>
                                                      <tr>
                                                        <th>ITEM ID</th>
                                                        <th className="w-60">
                                                          PRODUCT NAME
                                                        </th>
                                                        <th>QTY</th>
                                                        <th>UNIT</th>
                                                        <th>PRICE($)</th>
                                                        <th>TOTAL($)</th>
                                                      </tr>
                                                    </thead>

                                                    <tbody>
                                                      {this.state.rows_optional.map(
                                                        (row, index) => (
                                                          <>
                                                            {row.data.type &&
                                                            row.data.type ===
                                                              "service" ? (
                                                              <tr
                                                                key={`ind${index}`}
                                                              >
                                                                <td>
                                                                  {row.data
                                                                    .id &&
                                                                  row.data
                                                                    .id !== ""
                                                                    ? row.data
                                                                        .id
                                                                    : "---"}
                                                                </td>
                                                                <td>
                                                                  {row.data
                                                                    .name !== ""
                                                                    ? row.data
                                                                        .name &&
                                                                      row.data
                                                                        .name !==
                                                                        ""
                                                                      ? row.data
                                                                          .name
                                                                      : "---"
                                                                    : null}
                                                                </td>
                                                                <td>
                                                                  {
                                                                    row.data
                                                                      .quantity
                                                                  }
                                                                </td>
                                                                <td>
                                                                  {
                                                                    row.data
                                                                      .unit
                                                                  }
                                                                </td>
                                                                <td>
                                                                  $
                                                                  {Number(
                                                                    row.data
                                                                      .price,
                                                                  ).toFixed(2)}
                                                                </td>
                                                                <td>
                                                                  $
                                                                  {
                                                                    row.data
                                                                      .total
                                                                  }
                                                                </td>
                                                              </tr>
                                                            ) : row.data
                                                                .type ===
                                                              "section" ? (
                                                              <tr
                                                                key={`ind${index}`}
                                                              >
                                                                <td
                                                                  className="text-left"
                                                                  colSpan={6}
                                                                >
                                                                  <strong>
                                                                    {row.data
                                                                      .name !==
                                                                    ""
                                                                      ? row.data
                                                                          .name &&
                                                                        row.data
                                                                          .name !==
                                                                          ""
                                                                        ? row
                                                                            .data
                                                                            .name
                                                                        : "---"
                                                                      : null}
                                                                  </strong>
                                                                </td>
                                                              </tr>
                                                            ) : null}
                                                          </>
                                                        ),
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ) : null}
                                        {this.state.rfq_requirements &&
                                        this.state.rfq_requirements !== "" ? (
                                          <div className="accordion-item">
                                            <a
                                              href="#"
                                              className="accordion-head collapsed"
                                              data-toggle="collapse"
                                              data-target="#accordion-item-2-3"
                                            >
                                              <h6 className="title">
                                                Received RFQ
                                              </h6>
                                              <span className="accordion-icon"></span>
                                            </a>
                                            <div
                                              className="accordion-body collapse "
                                              id="accordion-item-2-3"
                                              data-parent="#accordion-2"
                                            >
                                              <div className="accordion-inner">
                                                <div className="row g-gs">
                                                  <div className="col-xxl-12">
                                                    <h5>Requirements</h5>
                                                    <div
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          this.state
                                                            .rfq_requirements,
                                                      }}
                                                    />
                                                  </div>
                                                  {this.state.rfq_attachment &&
                                                  this.state.rfq_attachment !==
                                                    "" ? (
                                                    <div className="col-xxl-12">
                                                      <h5>Attachment</h5>
                                                      <table className="table table-striped">
                                                        <tbody>
                                                          <tr>
                                                            <td>
                                                              Download
                                                              Attachment
                                                            </td>
                                                            <td>
                                                              <a
                                                                onClick={() =>
                                                                  this.downloadPdfRfq(
                                                                    this.state
                                                                      .rfq_attachment,
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                title="Download Attachment"
                                                              >
                                                                <span className="badge badge-outline-secondary">
                                                                  {" "}
                                                                  <em className="icon ni ni-download"></em>{" "}
                                                                  Download
                                                                  Attachment
                                                                </span>
                                                              </a>
                                                            </td>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  ) : null}
                                                  {this.state
                                                    .rows_rfq_services &&
                                                  this.state.rows_rfq_services
                                                    .length > 0 ? (
                                                    <div className="col-xxl-12">
                                                      <h5>
                                                        RFQ Products & Services
                                                      </h5>

                                                      <table className="table table-striped">
                                                        <thead>
                                                          <tr>
                                                            <th className="w-150px">
                                                              ITEM ID
                                                            </th>
                                                            <th className="w-60">
                                                              Product name
                                                            </th>
                                                            <th>Quantity</th>
                                                            <th>Unit</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {this.state.rows_rfq_services.map(
                                                            (row, index) => (
                                                              <tr key={index}>
                                                                <td>
                                                                  {row.data.id}
                                                                </td>
                                                                <td>
                                                                  {
                                                                    row.data
                                                                      .name
                                                                  }
                                                                </td>
                                                                <td>
                                                                  {
                                                                    row.data
                                                                      .quantity
                                                                  }
                                                                </td>
                                                                <td>
                                                                  {
                                                                    row.data
                                                                      .unit
                                                                  }
                                                                </td>
                                                              </tr>
                                                            ),
                                                          )}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  ) : null}
                                                  {this.state
                                                    .rows_rfq_questions &&
                                                  this.state.rows_rfq_questions
                                                    .length > 0 ? (
                                                    <div className="col-xxl-12">
                                                      <h5>Questions</h5>

                                                      <table className="table table-striped">
                                                        <thead>
                                                          <tr>
                                                            <th className="w-150px">
                                                              Question
                                                            </th>
                                                            <th className="w-60">
                                                              Answer
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {this.state.rows_rfq_questions.map(
                                                            (rfq, index) => (
                                                              <tr key={index}>
                                                                <td>
                                                                  {rfq.question}
                                                                </td>
                                                                <td>
                                                                  {rfq.answer}
                                                                </td>
                                                              </tr>
                                                            ),
                                                          )}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  ) : null}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/*** Details Modal ***/}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
    userRoleItems: state.userRoleItems,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Quotations));
